import Cookies from "universal-cookie";
import { I18nManager, Platform } from "react-native";
const cookies = new Cookies();
const addToken = (token) => {
  return { type: "ADD_TOKEN", token: token };
};
const login = (token, role) => {
  return { type: "LOGIN", token: token, role: role };
};
const changeLanguage = (language) => {
  return { type: "CHANGE_LANGUAGE", language: language };
};

const refresh = () => {
  return { type: "REFRESH" };
};

const setRtl = () => {
  let rtl = false;
  let lang = "english";
  if (Platform.OS === "web") {
    const language = cookies.get("language");
    if (language === undefined || language === null || language === "english") {
      rtl = false;
      lang = "english";
    } else {
      rtl = true;
      lang = "persian";
    }
  } else {
    if (I18nManager.isRTL) {
      rtl = true;
      lang = "persian";
    } else {
      rtl = false;
      lang = "english";
    }
  }

  return { type: "SET_RTL", rtl: rtl, language: lang };
};

export { addToken, login, changeLanguage, setRtl, refresh };
